import {SHOW_LOGIN_MODAL, FETCH_AUTH_USER, SET_AUTH_USER, SET_AUTH_FETCH, CLEAR_AUTH_USER} from "../actions/auth";

interface IAuthReducer {
  userData: object | null;
  isFetching: boolean;
  isShow: boolean;
}

const initialState: IAuthReducer = {
  userData: null,
  isFetching: false,
  isShow: false
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_AUTH_USER:
      return {
        ...state,
        userData: null,
        isFetching: true,
        isShow: false
      };
    case SET_AUTH_USER:
      return {
        ...state,
        userData: action.payload,
        isFetching: false,
        isShow: false
      };
    case SHOW_LOGIN_MODAL:
      return {
        ...state,
        isShow: action.payload,
        isFetching: false
      };
    case SET_AUTH_FETCH:
      return {
        ...state,
        isFetching: action.payload
      };
    case CLEAR_AUTH_USER:
      return{
        ...initialState
      };
    default:
      return state;
  }
};
